import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Link, browserHistory, withRouter } from "react-router";
import api from "../../api/apiUtil";
import Title from "../../components/Layout/Title";
import MaskDate from "../../components/Util/MaskDate";
import ReactTable from "react-table";
import "./Survey.css";

const SurveyResponses = ({ params }) => {
  const [survey, setSurvey] = useState(null);
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedResponse, setSelectedResponse] = useState(null);

  useEffect(() => {
    loadSurveyAndResponses();
  }, [params.id]);

  const loadSurveyAndResponses = () => {
    // Load survey details
    Promise.resolve(api.Survey.get(params.id))
      .then((surveyData) => {
        setSurvey(surveyData);
        // Load responses
        return Promise.resolve(api.Survey.getResponses(params.id));
      })
      .then((responseData) => {
        // Parse the JSON response data for each response
        const parsedResponses = responseData.map(response => {
          try {
            const parsedResposta = typeof response.resposta === 'string' ? JSON.parse(response.resposta) : response.resposta;
            return {
              ...response,
              resposta: parsedResposta
            };
          } catch (err) {
            console.error("Failed to parse response data", err);
            return response;
          }
        });
        setResponses(parsedResponses);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load survey or responses", err);
        toastr.error("Erro", "Falha ao carregar as respostas da pesquisa");
        setLoading(false);
      });
  };

  const openResponseModal = (response) => {
    setSelectedResponse(response);
    setModalOpen(true);
  };

  const closeResponseModal = () => {
    setModalOpen(false);
    setSelectedResponse(null);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('pt-BR');
  };

  // Função para obter o nome do tipo de pergunta
  const getQuestionTypeName = (type) => {
    switch (type) {
      case "text":
        return "Texto Aberto";
      case "choice":
        return "Múltipla Escolha";
      case "rating":
        return "Avaliação (5 Estrelas)";
      case "likert":
        return "Escala Likert";
      default:
        return type;
    }
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (!survey) {
    return <div>Pesquisa não encontrada</div>;
  }

  return (
    <div>
      <Title routes={[{ name: "Respostas da Pesquisa de Satisfação" }]} description="Respostas da Pesquisa de Satisfação" />
      
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="hpanel">
              <div className="panel-heading">
                <div className="panel-tools">
                  <Link className="btn btn-xs btn-default" onClick={browserHistory.goBack}>
                    <i className="fas fa-arrow-left"></i> Voltar
                  </Link>
                </div>
                <h3>{survey.titulo}</h3>
                <p>
                  Período: {new Date(survey.dataInicio).toLocaleDateString('pt-BR')}
                  {survey.dataFim && ` até ${new Date(survey.dataFim).toLocaleDateString('pt-BR')}`}
                </p>
                <p>Total de respostas: {responses.length}</p>
              </div>
              
              <div className="panel-body">
                {responses.length === 0 ? (
                  <p>Nenhuma resposta registrada ainda.</p>
                ) : (
                  <div className="responses-list">
                    <ReactTable
                      className="-striped -highlight"
                      data={responses}
                      defaultPageSize={10}
                      loadingText="Carregando..."
                      noDataText="Nenhuma resposta encontrada"
                      previousText="Anterior"
                      nextText="Próximo"
                      pageText="página"
                      ofText="de"
                      rowsText="linhas"
                      showPageSizeOptions={false}
                      minRows={1}
                      columns={[
                        {
                          Header: "Nome do Usuário",
                          accessor: "nomeUsuario",
                          className: "align-middle",
                          headerClassName: "font-extra-bold",
                          Cell: (row) => row.original.nomeUsuario || 'Não disponível'
                        },
                        {
                          Header: "CPF",
                          accessor: "cpfUsuario",
                          className: "align-middle",
                          headerClassName: "font-extra-bold",
                          Cell: (row) => row.original.cpfUsuario || 'Não disponível'
                        },
                        {
                          Header: "Razão Social da Financeira",
                          accessor: "razaoSocialFinanceira",
                          className: "align-middle",
                          headerClassName: "font-extra-bold",
                          Cell: (row) => row.original.razaoSocialFinanceira || 'Não disponível'
                        },
                        {
                          Header: "Horário da Resposta",
                          accessor: "dataResposta",
                          className: "align-middle text-center",
                          headerClassName: "font-extra-bold",
                          Cell: (row) => formatDate(row.original.dataResposta)
                        },
                        {
                          Header: "Ações",
                          className: "align-middle text-center",
                          headerClassName: "font-extra-bold",
                          width: 120,
                          Cell: (row) => (
                            <button 
                              className="btn btn-primary btn-sm" 
                              onClick={() => openResponseModal(row.original)}
                            >
                              Ver Respostas
                            </button>
                          )
                        }
                      ]}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for viewing response details */}
      {modalOpen && selectedResponse && (
        <div className="modal-preview">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Resposta da Pesquisa</h3>
              <button className="close" onClick={closeResponseModal}>&times;</button>
            </div>
            <div className="modal-body">
              <div className="response-info">
                <p><strong>Usuário:</strong> {selectedResponse.nomeUsuario || 'Não encontrado'}</p>
                <p><strong>CPF:</strong> {selectedResponse.cpfUsuario || 'Não encontrado'}</p>
                <p><strong>Financeira:</strong> {selectedResponse.razaoSocialFinanceira || 'Não encontrada'}</p>
                <p><strong>Data da Resposta:</strong> {formatDate(selectedResponse.dataResposta)}</p>
              </div>
              
              <div className="questions-preview">
                {selectedResponse.resposta && selectedResponse.resposta.perguntas ? (
                  selectedResponse.resposta.perguntas.map((question, index) => (
                    <div key={index} className="question-preview">
                      <h4>
                        {index + 1}. {question.titulo}
                        {question.obrigatoria && <span className="required"> *</span>}
                        <span className="question-type">({getQuestionTypeName(question.tipo)})</span>
                      </h4>
                      
                      {question.tipo === "choice" && (
                        <div className="options-preview">
                          {question.configuracao && question.configuracao.opcoes && question.configuracao.opcoes.map((option, optionIndex) => {
                            const isSelected = question.resposta === option.texto;
                            return (
                              <div key={optionIndex} className="option">
                                <input 
                                  type="radio" 
                                  checked={isSelected} 
                                  readOnly
                                /> 
                                {option.texto}
                                {isSelected && <strong> (Selecionado)</strong>}
                              </div>
                            );
                          })}
                        </div>
                      )}
                      
                      {question.tipo === "rating" && (
                        <div className="rating-preview">
                          {(() => {
                            const scale = question.configuracao && question.configuracao.escala ? question.configuracao.escala : 5;
                            return Array.from({ length: scale }, (_, i) => (
                              <span 
                                key={i} 
                                className={`star ${question.resposta > i ? 'filled' : ''}`}
                              >
                                ★
                              </span>
                            ));
                          })()}
                          <span className="rating-value">({question.resposta}/{question.configuracao?.escala || 5})</span>
                        </div>
                      )}
                      
                      {question.tipo === "likert" && (
                        <div className="likert-preview">
                          <table>
                            <thead>
                              <tr>
                                <th></th>
                                {question.configuracao && question.configuracao.opcoesLikert && question.configuracao.opcoesLikert.map((option, optionIndex) => (
                                  <th key={optionIndex} className="text-center">{option.texto}</th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {question.configuracao && question.configuracao.itensLikert && question.configuracao.itensLikert.map((item, itemIndex) => {
                                const responseValue = question.resposta && question.resposta[itemIndex] ? question.resposta[itemIndex] : null;
                                return (
                                  <tr key={itemIndex}>
                                    <td>{item.titulo}</td>
                                    {question.configuracao.opcoesLikert && question.configuracao.opcoesLikert.map((option, optionIndex) => (
                                      <td key={optionIndex} className="text-center">
                                        <input 
                                          type="radio" 
                                          checked={responseValue === option.id} 
                                          readOnly 
                                        />
                                      </td>
                                    ))}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      )}
                      
                      {question.tipo === "text" && (
                        <div className="text-preview">
                          <textarea 
                            value={question.resposta || ''} 
                            readOnly 
                            rows="3"
                          />
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <p>Detalhes da resposta não disponíveis</p>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-default" onClick={closeResponseModal}>Fechar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default connect()(withRouter(SurveyResponses));